import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85b87f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "selected-persons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_ctx.persons.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePersons, (person, i) => {
          return (_openBlock(), _createBlock(_component_q_avatar, {
            key: person.id,
            size: "32px",
            color: "grey-3",
            "text-color": "grey-6",
            class: "selected-person cursor-pointer",
            style: _normalizeStyle({ zIndex: _ctx.persons.length - i }),
            onClick: ($event: any) => (_ctx.$emit('deselect', person.id))
          }, {
            default: _withCtx(() => [
              (person.primaryFace && person.primaryFace.imageUrl)
                ? (_openBlock(), _createBlock(_component_q_img, {
                    key: 0,
                    src: person.primaryFace.imageUrl,
                    ratio: 1,
                    fit: "cover"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "fa fa-user",
                    size: "xs"
                  })),
              _createVNode(_component_q_tooltip, { delay: 300 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(person.label || 'Unnamed'), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["style", "onClick"]))
        }), 128)),
        (_ctx.overflowCount > 0)
          ? (_openBlock(), _createBlock(_component_q_avatar, {
              key: 0,
              size: "32px",
              color: "primary",
              "text-color": "white",
              class: "selected-person text-caption"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" +" + _toDisplayString(_ctx.overflowCount), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}